var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"middle-banner-section"},[_c('p',[_vm._v("List your property on Bongalo and open your doors to rental income.")]),_c('button',{on:{"click":_vm.handleOpeningHostPage}},[_vm._v("List")])])}
var staticRenderFns = []

export { render, staticRenderFns }